module.exports = __webpack_public_path__ + "img/lemn_3kl.aceb46a3.jpg";